import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import Button from '../../../components/ui/Button';
import Card from '../../../components/ui/Card';
import GoogleIcon from '../../../components/icons/GoogleIcon';
import MicrosoftIcon from '../../../components/icons/MicrosoftIcon';

const ClassManagementHome: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, login, logout, loginWithGoogle, loginWithMicrosoft, userRole } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLoginSuccess = () => {
    if (userRole === 'student') {
      navigate('/class/student');
    } else {
      navigate('/class/teacher/ClassTeacherHome');
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      handleLoginSuccess();
    } catch (err) {
      setError('로그인에 실패했습니다. 이메일과 비밀번호를 확인해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (err) {
      setError('로그아웃에 실패했습니다.');
    }
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: 24 }}>
      <div style={{ marginTop: 64, marginBottom: 32 }}>
        <h1 style={{ textAlign: 'center', marginBottom: 8, fontSize: 28 }}>MARU 학급 경영</h1>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: 24, fontSize: 18 }}>
          효율적인 학급 경영을 위한 통합 플랫폼
        </p>
        <Card padding="32px" style={{ marginBottom: 24 }}>
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            학급 경영 프로그램은 선린중학교 이혜명 선생님과 김희성 선생님, 한지호 선생님 아이디어로 시작한 프로젝트입니다.<br />
            학급 경영을 위하여 만들게 되었으며, 개인정보에 대한 문제가 생길 시 책임 소지는 사용자 본인에게 있습니다.<br />
            1인 개발로 업데이트가 매우 늦으며, 오류가 많을 수 있습니다.<br />
            문제가 있을 시 한지호 선생님에게 문의해주세요.<br />
            이메일 문의: jihotech16@gmail.com
          </p>
        </Card>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Card padding="32px">
          <h2 style={{ marginBottom: 16, fontSize: 20 }}>환영합니다</h2>
          <Button
            variant="outline"
            onClick={() => navigate('/login', { state: { from: { pathname: location.pathname } } })}
            style={{ width: '100%' }}
          >
            로그인 하러 가기
          </Button>
        </Card>

        <Card padding="32px">
          <h2 style={{ marginBottom: 8, fontSize: 20 }}>주요 기능</h2>
          <p style={{ color: '#666', marginBottom: 16, fontSize: 14 }}>
            MARU에서 제공하는 다양한 학급 경영 기능을 확인해보세요.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Card padding="16px" style={{ border: '1px solid var(--Color-line-normal)' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ marginRight: 8 }}>🏫</span>
                <h3 style={{ margin: 0, fontSize: 16 }}>학급 관리</h3>
              </div>
              <p style={{ margin: 0, color: '#666', fontSize: 14 }}>
                학급 정보 관리, 학생 관리, 학급 일정 관리 등
              </p>
            </Card>
            <Card padding="16px" style={{ border: '1px solid var(--Color-line-normal)' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ marginRight: 8 }}>👥</span>
                <h3 style={{ margin: 0, fontSize: 16 }}>학생 관리</h3>
              </div>
              <p style={{ margin: 0, color: '#666', fontSize: 14 }}>
                학생 정보 관리, 출석 관리, 상담 기록 등
              </p>
            </Card>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ClassManagementHome;
